{
  "segments": {
    "new": "New",
    "active": "Active",
    "vip": "VIP",
    "at_risk": "At risk",
    "churned": "Churned",
    "wholesale": "Wholesale"
  },
  "loyalty": {
    "bronze": "Bronze",
    "silver": "Silver",
    "gold": "Gold",
    "platinum": "Platinum"
  },
  "languages": {
    "fr": "French",
    "wo": "Wolof",
    "en": "English"
  },
  "list": {
    "title": "Customers",
    "all": "All",
    "search_placeholder": "Search by name or phone...",
    "empty": "No customers",
    "empty_description": "No customers match the search criteria",
    "col_name": "Name",
    "col_phone": "Phone",
    "col_segment": "Segment",
    "col_total_spent": "Total spent",
    "col_last_order": "Last order",
    "col_loyalty": "Loyalty",
    "load_error": "Unable to load customers",
    "load_error_hint": "Please check your connection and try again."
  },
  "customer": {
    "not_found": "Customer not found",
    "total_orders": "Total orders",
    "total_spent": "Total spent",
    "last_order": "Last order",
    "member_since": "Member since",
    "details": "Details",
    "preferred_payment": "Preferred payment",
    "preferred_language": "Preferred language",
    "addresses": "Addresses",
    "tags": "Tags",
    "notes": "Notes",
    "no_notes": "No notes for this customer",
    "add_note": "Add",
    "add_note_placeholder": "Add a note..."
  },
  "dashboard": {
    "title": "Customer segments",
    "total_customers": "total customers",
    "clients": "customers",
    "avg_spend": "Average spend",
    "create_campaign": "Create campaign"
  },
  "campaign": {
    "create_title": "New campaign",
    "name": "Campaign name",
    "name_placeholder": "E.g., Ramadan Promo Countre Dairy",
    "type": "Channel",
    "types": {
      "sms": "SMS",
      "whatsapp": "WhatsApp",
      "email": "Email"
    },
    "target_segment": "Target segment",
    "estimated_reach": "customers will be reached",
    "message": "Message",
    "message_placeholder": "Write your message here...",
    "characters": "characters",
    "preview": "Preview",
    "schedule": "Send date and time",
    "cancel": "Cancel",
    "create": "Create campaign",
    "status": {
      "draft": "Draft",
      "scheduled": "Scheduled",
      "sending": "Sending",
      "completed": "Completed",
      "cancelled": "Cancelled"
    }
  }
}
